import React from 'react';
import { Link } from 'gatsby';

const BottomCta = ({
    className = '',
    icon,
    iconAlt,
    btnText,
    btnClass,
    btnURL,
    mediaClass = '',
    iconStyle = {}
}) => {
    return (
        <div className={`bottomcta ${className}`}>
            <div className={`media ${mediaClass}`}>
                <img src={icon} alt={iconAlt}  style={iconStyle} />
            </div>
            <div className="btn-wrap">
                {btnText ? (
                    <Link className={`btn ${btnClass}`} to={btnURL}>{btnText}</Link>
                ) : ""}
            </div>
        </div>
    )
}

export default BottomCta;